<div class="calendar-container" *ngIf="viewModel$ | async as viewModel">
  <p-calendar
    class="max-w-full"
    selectionMode="range"
    [ngModel]="viewModel.timeline"
    (ngModelChange)="
      store.dispatch(
        actions.timelineDatesSelected({ timeline: getTimeline($event) })
      )
    "
    (onMonthChange)="
      store.dispatch(
        actions.monthChanged({ month: $event.month, year: $event.year })
      )
    "
    [inline]="true"
    [readonlyInput]="true"
    [selectOtherMonths]="true"
    [appHighlightDates]="viewModel.highlightDates"
  />
  <div *ngFor="let remark of viewModel.dateRemarks" class="remark-container">
    <p-message
      [severity]="remark.severity"
      [text]="remark.date + ': ' + remark.text"
    ></p-message>
  </div>
</div>
